import { z } from 'zod';

import type { Json } from './database.types';

export const contactConsentStatusSchema = z.enum(['unknown', 'opted_in', 'opted_out']);

export const contactUpsertInputSchema = z.object({
  tenantId: z.string().trim().min(1),
  venueId: z.string().nullable().optional(),
  userId: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  consentStatus: contactConsentStatusSchema.nullable().optional(),
  source: z.string().nullable().optional(),
  sourceDetail: z.custom<Json>().nullable().optional(),
});

export const registrationFormFieldTypeSchema = z.enum([
  'multiple_choice',
  'short_text',
  'long_text',
]);

export const registrationFormFieldSchema = z.object({
  id: z.string().trim().min(1),
  label: z.string(),
  options: z.array(z.string()).optional(),
  required: z.boolean(),
  type: registrationFormFieldTypeSchema,
});

export const registrationFormSchema = z.object({
  fields: z.array(registrationFormFieldSchema).max(20),
  version: z.literal(1),
});

export const registrationFormResponsesSchema = z.record(z.string(), z.string());

export const eventLinkDraftSchema = z.object({
  id: z.string().nullable().optional(),
  label: z.string(),
  sortOrder: z.number().int().optional(),
  url: z.string(),
});

export const eventMediaUploadInputSchema = z.object({
  duration: z.number().nonnegative().nullable().optional(),
  mediaKind: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  size: z.number().nonnegative().nullable().optional(),
  type: z.string().nullable().optional(),
});

export type ContactUpsertInput = Readonly<z.infer<typeof contactUpsertInputSchema>>;
export type EventLinkDraft = Readonly<z.infer<typeof eventLinkDraftSchema>>;
export type EventMediaUploadInput = Readonly<z.infer<typeof eventMediaUploadInputSchema>>;
export type RegistrationFormField = Readonly<z.infer<typeof registrationFormFieldSchema>>;
export type RegistrationFormFieldType = z.infer<typeof registrationFormFieldTypeSchema>;
export type RegistrationFormResponses = z.infer<typeof registrationFormResponsesSchema>;
